<template>
  <footer class="footer">
    <app-sponsors v-if="displaySponsors" />
    <div class="footer-links ">
      <div class="container pb-0">
        <div class="row px-md-3">
          <div class="col-6 col-md-3 column">
            <h5 title="About our global citizen science support organization" alt="About our global citizen science support organization">
              <b-link :to="{ name: 'About' }" id="FooterTitleLink">About</b-link>
            </h5>
            <ul>
              <li title="Our impact" alt="Our impact">
                <b-link :to="{ name: 'Impact' }">Our Impact</b-link>
              </li>
              <li title="Our mission" alt="Our mission">
                <b-link :to="{ name: 'Mission' }">Mission</b-link>
              </li>
              <li title="Our team" alt="Our team">
                <b-link :to="{ name: 'Staff' }">Team</b-link>
              </li>
              <li title="Our citizen science partners" alt="Our partners">
                <b-link :to="{ name: 'Partners' }">Partners</b-link>
              </li>
              <li title="Participatory Science Publications" alt="Participatory Science Publications">
                <b-link :to="{ name: 'Publications' }">Publications</b-link>
              </li>
              <li title="FAQs" alt="FAQs">
                <b-link :to="{ name: 'Faqs' }">FAQs</b-link>
              </li>
            </ul>
          </div>
          <div class="col-6 col-md-3 column">
            <h5 title="Our citizen science solutions" alt="Our citizen science solutions">
              <b-link :to="{ name: 'Solutions' }" id="FooterTitleLink">Solutions</b-link>
            </h5>
            <ul>
              <li  title="Our services" alt="Our services">
                <b-link :to="{ name: 'Services' }" >Services</b-link>
              </li>
              <li>
                <b-link :to="{ name: 'Create' }">Create</b-link>
              </li>
              <li>
                <b-link :to="{ name: 'Build' }">Build</b-link>
              </li>
              <li>
                <b-link :to="{ name: 'Measure' }">Measure</b-link>
              </li>
              <li>
                <b-link :to="{ name: 'Learn' }">Learn</b-link>
              </li>
              <li>
                <b-link :to="{ name: 'Act' }">Act</b-link>
              </li>
            </ul>
          </div>
          <div class="col-6 col-md-3 column">
            <h5 title="For Developers" alt="For Developers">
              <b-link :to="{ name: 'Developers' }" id="FooterTitleLink">Developers</b-link>
            </h5>
            <ul>
              <li>
                <b-link :to="{ name: 'Apis' }">API</b-link>
              </li>
              <li>
                <b-link :to="{ name: 'Widgets' }">Widgets</b-link>
              </li>
              <li>
                <b-link :to="{ name: 'Apps' }">Mobile Apps</b-link>
              </li>
              <li>
                <b-link :to="{ name: 'Architecture' }">Architecture</b-link>
              </li>
              <li>
                <b-link :to="{ name: 'Developers' }">PPSR CORE</b-link>
              </li>
            </ul>
          </div>
          <div class="col-6 col-md-3 column">
            <h5 title="Connect" alt="Connect">
              <b-link :to="{ name: 'Connect' }" id="FooterTitleLink">Connect</b-link>
            </h5>
            <ul>
              <li>
                <a href="https://blog.citsci.org/">Blog</a>
              </li>
              <li>
                <b-link :to="{ name: 'Newsletter' }">Newsletter</b-link>
              </li>
              <li>
                <b-link :to="{ name: 'Webinars' }">Webinars</b-link>
              </li>
              <li>
                <b-link :to="{ name: 'Surveys' }">Surveys</b-link>
              </li>
              <li>
                <b-link :to="{ name: 'Contact' }">Contact Us</b-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="licence d-flex">
      <b-container id="footer-container" class="py-0">
      <div class="row">
        <div class="column col-sm-6 mx-auto">
          <div class="icon">
            <a style="float:left; margin-right: 12px; margin-bottom: 2px;" rel="license" href="https://creativecommons.org/licenses/by/3.0/deed.en_US">
              <img alt="Creative Commons License" style="border-width:0; margin-top:6px;" src="https://i.creativecommons.org/l/by/3.0/88x31.png">
            </a>
          </div>
          <div style="color: #22252C;">
            <span xmlns:dct="https://purl.org/dc/terms/" property="dct:title">CitSci.org</span> data are licensed under a <a id="CreativeCommonsLink" rel="license" href="https://creativecommons.org/licenses/by/3.0/deed.en_US">CC-BY 3.0 License</a>.
            Please see our <b-link to="termsandprivacy" id="CreativeCommonsLink">Terms and Privacy</b-link> for further details.
          </div>
        </div>
        <div class="column col-sm-6 mx-auto">
          <div class="CCIcons">
            <a href="https://www.colostate.edu/" target="_blank" rel="noopener noreferrer">
              <img class="footer-image" src="/assets/images/footer/CSU-Official-wrdmrk-Rev.png" alt="CSU" title="CSU" />
            </a>

            <a href="https://nrel.colostate.edu" target="_blank" rel="noopener noreferrer">
              <img class="footer-image" src="/assets/images/footer/SupportedBy_NREL.png" alt="NREL" title="NREL" />
            </a>

            <a href="https://www.nsf.gov/" target="_blank" rel="noopener noreferrer">
              <img class="footer-image" src="/assets/images/footer/SupportedBy_NSF.png" alt="NSF" title="NSF" />
            </a>

            <a href="https://www.facebook.com/pages/CitSciorg/172382202839106" target="_blank" rel="noopener noreferrer" alt="Visit our Facebook page" title="Visit our Facebook page">
              <img class="footer-image" src="/assets/images/footer/facebook_footer.png">
            </a>
<!--            <a href="https://twitter.com/citsci/" target="_blank" rel="noopener noreferrer" alt="Tweet about CitSci.org" title="Tweet about CitSci.org">-->
<!--              <img class="footer-image" src="/assets/images/footer/twitter_footer.png">-->
<!--            </a>-->
            <span class="h-100 d-inline-block" style="vertical-align: bottom;">
              <a href="https://www.youtube.com/@citsci7428" class="text-white" target="_blank" rel="noopener noreferrer" alt="Visit our YouTube Channel" title="Visit our YouTube Channel">
                <font-awesome-icon :icon="['fab', 'youtube']" class="footer-image" style="font-size:24pt;"/>
              </a>
              <a href="https://www.instagram.com/citsci_org/" class="text-white" target="_blank" rel="noopener noreferrer" alt="Visit out Instagram page" title="Visit our Instagram page">
                <font-awesome-icon :icon="['fab', 'instagram']" class="footer-image" style="font-size:24pt;"/>
              </a>
            </span>
          </div>
        </div>
      </div>
      </b-container>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'BootstrapVueFooter',

  props: {
    displaySponsors: {
      type: Boolean,
      default: false
    }
  }
}

</script>

<style lang="scss">

#FooterTitleLink { color:#ffffff; }
#FooterTitleLink:hover { color:#fafafa; text-decoration:none; } /* 87983F 808080*/

.footer {
  .footer-links {
    background-color: #22252C;

    .row {

      .column {

        h5 {
          color: #fff;
          font-size: 1.3em;
          font-weight: normal;
          line-height: 2.0em;
        }

        h5:hover {
          text-decoration: underline;
          text-decoration-color: #808080;
        }

        ul {
          list-style: none;
          padding: 0;
          font-size: 16px;

          li {
            color: #808080;

            a {
              &:link, &:visited, &:focus {
                color: #808080;
              }

              &:hover {
                text-decoration: none;
                color: #fff;
              }
            }
          }
        }
      }
    }


  }

  .licence {
    display: flex;
    justify-content: center;
    background-color: #87983F;
    align-items: center;

    .row {
      font-size: 12px;
      flex-direction: row;
      max-width: 1400px;
      justify-content: center;
      margin: 5px 0;

      .column {
        flex-direction: column;
        margin: 0 40px;
        align-items: center;
        align-content: center;
        max-width: 800px;

        @media screen and (max-width: 977px) {
          margin: 5px 40px;
        }

        .text {
          width: 400px;

          a {
            text-decoration: none;
            font-weight: bold;
            color: #393835;

            &:hover, &:focus {
              color: #fff;
            }
          }
        }

        .CCIcons {
          img {
            height: 38px;
            width: auto;
          }
        }
      }
    }
  }
}
</style>
